import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=25e6b116&scoped=true"
import script from "./OffersTable.vue?vue&type=script&lang=js"
export * from "./OffersTable.vue?vue&type=script&lang=js"
import style0 from "./OffersTable.vue?vue&type=style&index=0&id=25e6b116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6b116",
  null
  
)

export default component.exports